export const HANDLE_API_CALL_EXCEPTION = 'handle_api_call_exception'
